import {Injectable} from '@angular/core';
import {IRecuperationListeDonneesMetier} from '@app/core/interfaces';
import {Observable} from 'rxjs';
import {Autowired} from '@angular-ru/autowired';
import { ActeRealiseDetailsTableListeRestApiService } from './acte-realise-details-table.liste.rest-api.service';


@Injectable({providedIn: 'root'})
export class ActeRealiseDetailsTableListeMetierService implements IRecuperationListeDonneesMetier {
  @Autowired() restApi: ActeRealiseDetailsTableListeRestApiService;

  requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
    // console.log('data : ', data);
    // console.log('args : ', args);

    return this.restApi.requeteRecuperationListeDonnees(data, args);
  }

  recupererPoursuiteActeResRealise(data: any) {
    return this.restApi.recupererPoursuiteActeResRealise(data);
  }
}
